module.exports = __webpack_public_path__ + "img/xtdd-title2.8b363cff.png";